import React from "react";

import { TitleAndStatusContainer, Title, StatusContainer, Date, Close, Row, Jumbotron, JumbotronTitle, InfoTitle, Info } from "./styles";

//Interfaces
import { ModalDetailsPropsInterface } from "./interfaces";

//Assets
import colors from "../../assets/css/colors";
import close from "../../assets/icons/close.svg";

import moment from "moment";

//Utils
import { translatePaymentType } from "../../utils/translate/paymentType";
import { translateStatus } from "../../utils/translate/status";

const ModalTransfers = (props: ModalDetailsPropsInterface) => {
    const statusContainerBackgroundDefiner = (status: string) => {
        const objStatus = {
            succeeded: colors.greenDark,
            failed: colors.redDark
        }

        return objStatus[status as keyof typeof objStatus]
            ?? colors.gray
    }
    
    return (        
        <div className="modal fade" id={props.id}  aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-details">
                <div className="modal-content">
                    <div className="modal-header d-flex justify-content-between mb-0 pb-0">
                        <div>
                            <TitleAndStatusContainer>
                                <Title>Detalhes da transferência</Title>
                                <StatusContainer color={statusContainerBackgroundDefiner(props.data.status)}>{translateStatus(props.data.status)}</StatusContainer>
                            </TitleAndStatusContainer>
                            <Date>{moment(props.data.transfer_date).format("DD/MM/YYYY hh:mm")}</Date>
                        </div>
                        <Close data-dismiss="modal" aria-label="Close">
                            <img src={close} alt="fechar"/>
                        </Close>
                    </div>
                    <div className="modal-body">
                        <Row>
                            <Jumbotron>
                                <JumbotronTitle>Transferência</JumbotronTitle>
                                <InfoTitle>VALOR</InfoTitle>
                                <Info>R$ {props.data.amount}</Info>
                                <InfoTitle>Tipo de transferência</InfoTitle>
                                <Info>{translatePaymentType(props.data.type)}</Info>
                                <InfoTitle>Nome do titular</InfoTitle>
                                <Info>{props.data.bank_account.holder_name}</Info>
                                <InfoTitle>CPF/CNPJ</InfoTitle>
                                <Info>{props.data.bank_account.taxpayer_id}</Info>
                                {/* <InfoTitle>E-mail</InfoTitle>
                                <Info>contato@colegiomoreira.com.br</Info> */}
                            </Jumbotron>
                            
                            <Jumbotron>
                                <JumbotronTitle>Favorecido</JumbotronTitle>
                                <InfoTitle>Nome do titular</InfoTitle>
                                <Info>{props.data.bank_account.holder_name}</Info>
                                <InfoTitle>CNPJ</InfoTitle>
                                <Info>{props.data.bank_account.taxpayer_id}</Info>
                                <InfoTitle>Banco</InfoTitle>
                                <Info>{props.data.bank_account.bank_name}</Info>
                                <InfoTitle>Agência</InfoTitle>
                                <Info>{props.data.bank_account.routing_number}</Info>
                                <InfoTitle>Conta</InfoTitle>
                                <Info>{props.data.bank_account.account_number}</Info>
                            </Jumbotron>
                        </Row>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalTransfers;